import { mapCredentialInfo, mapPosInfo, mapOrderInfo } from "@appetize/iw-common/mappers/ppiMappers";

export const getPartialPpiPayments = (reportedAmenities = []) => {
  const ppiPayments = [];

  reportedAmenities.forEach((reportedAmenity) => {
    reportedAmenity.payments.forEach((payment) => {
      ppiPayments.push({
        paymentType: payment.paymentType,
        subpaymentType: payment.subpaymentType,
        spent: payment.spent,
        paymentData: payment.paymentData,
        externalId: payment.externalId,
        credential: reportedAmenity.card,
        selection: reportedAmenity.selection,
        selectionType: reportedAmenity.selectionType
      });
    });
  });

  return ppiPayments;
};

class CheckoutDTO {
  static getProcessPaymentPayload(amenity, OAPICart, rootGetters, reportedAmenities) {
    return {
      amount: amenity.appliedAmenity,
      orderInfo: mapOrderInfo(
        OAPICart.deviceOrderUuid,
        OAPICart.total,
        OAPICart.subtotal,
        OAPICart.discounts,
        OAPICart.taxTotal,
        amenity?.selectedTender?.currency,
        rootGetters["cart/getCartItemsForCheckout"],
        getPartialPpiPayments(reportedAmenities),
        rootGetters["cart/getPpiRedemptions"]
      ),
      credentialInfo: mapCredentialInfo(amenity?.card, amenity?.selectedTender?.selection, amenity?.selectedTender.selectionType),
      posInfo: mapPosInfo(
        +rootGetters["venue/getActiveVenue"],
        +rootGetters["vendor/getActiveVendor"].id,
        +rootGetters["vendor/getActiveVendor"].defaultMobileOrderingAccountID
      ),
      timestamp: Date.now()
    };
  }

  /**
   * voids payment if checkout fails.
   * @link: https://jarvis.appetizeinc.com/docs/ppi/index
   * @param amenity
   * @param OAPICart
   * @param rootGetters
   * @returns {{amount: number, orderId: (*|string), paymentData: string, externalId: string, credentialInfo: {encType: string, credential: *, pin: string, encoded: boolean}, posInfo: {vendorType: number, vendorRoleId: number, venueId: number, vendorId: number, userName: string, vendorName: string, userId: number}}}
   */
  static getVoidPaymentPayload(amenity, OAPICart, rootGetters) {
    return {
      amount: amenity.appliedAmenity,
      externalId: amenity?.processedPayment?.externalId,
      orderId: OAPICart.deviceOrderUuid,
      paymentData: amenity?.processedPayment?.paymentData,
      credentialInfo: mapCredentialInfo(amenity?.card, amenity?.selectedTender?.selection, amenity?.selectedTender.selectionType),
      posInfo: mapPosInfo(
        +rootGetters["venue/getActiveVenue"],
        +rootGetters["vendor/getActiveVendor"].id,
        +rootGetters["vendor/getActiveVendor"].defaultMobileOrderingAccountID
      )
    };
  }
}

export default CheckoutDTO;
